<div id="content">
      <h1 i18n="@@itemhistory.history">Historia: </h1>

    <table>
      <div *ngFor = "let item of sortedHistory; let i = index">
        <thead>
          <tr>
            <th *ngFor = "let field of getHistoryFields(i,true)" [innerHTML]="field"></th>
          </tr>
        </thead>
        <tbody>
          <tr id="itemsTable" >
            <td *ngFor = "let field of getHistoryFields(i,false)" [innerHTML]="field"></td>
          </tr>
        </tbody>
    </div>
    </table>

</div>
